var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.6H13.25V3.3C13.25 2.95522 13.113 2.62456 12.8692 2.38076C12.6254 2.13696 12.2948 2 11.95 2H8.05C7.70522 2 7.37456 2.13696 7.13076 2.38076C6.88696 2.62456 6.75 2.95522 6.75 3.3V4.6H3.5V5.9H4.8V15.65C4.8 16.1672 5.00545 16.6632 5.37114 17.0289C5.73684 17.3946 6.23283 17.6 6.75 17.6H13.25C13.7672 17.6 14.2632 17.3946 14.6289 17.0289C14.9946 16.6632 15.2 16.1672 15.2 15.65V5.9H16.5V4.6ZM8.05 3.3H11.95V4.6H8.05V3.3ZM13.9 15.65C13.9 15.8224 13.8315 15.9877 13.7096 16.1096C13.5877 16.2315 13.4224 16.3 13.25 16.3H6.75C6.57761 16.3 6.41228 16.2315 6.29038 16.1096C6.16848 15.9877 6.1 15.8224 6.1 15.65V5.9H13.9V15.65Z",
    fill: "#EE2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35005 8.5H8.05005V13.7H9.35005V8.5Z",
    fill: "#EE2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9501 8.5H10.6501V13.7H11.9501V8.5Z",
    fill: "#EE2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.69b0237f3ab58c2ef22ec414731fd2d8.svg";
export { ForwardRef as ReactComponent };